import { Region } from '../../region/region';

export interface AdminFilters {
  orderAsc: boolean;
  global: boolean;
  regional: boolean;
  viewOnly: boolean;
  callCenterAgent: boolean;
  regions: number[];
}

export interface AdminEvent<AdministratorDTO> {
  action: 'changed' | 'deleted';
  payload: AdministratorDTO;
}

/**
 * Admin Info DTO
 * @property {number} id
 * @property {string} email
 * @property {string} name
 * @property {Region[]} regions
 * @property {string} oktaUuid
 * @property {string} role
 * @property {string} language
 * @property {string} picture
 */
export class AdministratorDTO {
  // prettier-ignore
  /**
   * @constructor
   */
  constructor( // NOSONAR
    public id: number,
    public email: string,
    public name: string,
    public regions: Region[],
    public oktaUuid: string,
    public role: string,
    public language: string,
    public picture: string
  ) {}

  /**
   * Factory method for adminList mock
   * @return {any[]}
   */
  static MockAdmins(): any[] {
    return [
      {
        id: 2,
        name: 'Julio Venancio',
        email: 'jvmj@cesar.org.br',
        role: 'GLOBAL_ADMIN',
        regions: [
          {
            id: 3,
            name: 'Colombia',
          },
        ],
      },
      {
        id: 7,
        name: 'Renato testando',
        email: 'rdj@cesar.org.br',
        role: 'GLOBAL_ADMIN',
        regions: [
          {
            id: 2,
            name: 'Brazil',
          },
        ],
      },
      {
        id: 22,
        name: 'Adriel Gonçalvesssss',
        email: 'ags3@cesar.org.br',
        role: 'GLOBAL_ADMIN',
        regions: [
          {
            id: 3,
            name: 'Colombia',
          },
        ],
      },
      {
        id: 1,
        name: 'Fernando Oliveira',
        email: 'foaj@cesar.org.br',
        role: 'REGIONAL_ADMIN',
        regions: [
          {
            id: 2,
            name: 'Brazil',
          },
        ],
      },
      {
        id: 5,
        name: 'Fabiana Bezerra',
        email: 'fabiana.bezerra@cesar.org.br',
        role: 'VIEW_ADMIN',
        regions: [
          {
            id: 2,
            name: 'Brazil',
          },
        ],
      },
    ];
  }
}
